import { DataGrid, esES } from '@mui/x-data-grid';
import { useState } from 'react';

const Table2 = ({ data, rowClick, height = 200, render, loading = null, pageSize = 10, getRowClassName, sx, buscar = false, pageSizeOptions=[5, 10, 20]  }) => {
  const { rows, columns, filter, sortModel } = data;
  const [state, setState] = useState('');

  const changeValue = ({ target: { value } }) => setState(value);

  return (
    <>
      <div className='card mb-1 d-flex flex-row'>
        {
          buscar &&
          <div className='d-flex flex-row p-2'>
            <label className='my-auto me-3' htmlFor='search' role='button'>
              Buscar
            </label>
            <input
              className='form-control'
              id='search'
              placeholder='Buscar...'
              type='search'
              value={state}
              onChange={changeValue}
            />
          </div>
        }
        {render && render()}
      </div>
      <div style={{ height: height, overflow: 'auto' }}>
        <DataGrid
          disableColumnMenu
          keepNonExistentRowsSelected
          columns={columns}
          density='compact'
          getRowClassName={getRowClassName ? getRowClassName : () => { }}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: pageSize,
              },
            },
            sorting: {
              sortModel: sortModel,
            },
          }}
          loading={loading}
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          pageSizeOptions={pageSizeOptions}
          rows={rows?.filter((el) => filter(el, state))}
          rowsPerPageOptions={[10]}
          sx={{ ...sx }}
          onRowClick={rowClick}
        />
      </div>
    </>
  );
};

export default Table2;
